import { render, staticRenderFns } from "./ComplianceText.vue?vue&type=template&id=3f427a8f&"
import script from "./ComplianceText.vue?vue&type=script&lang=js&"
export * from "./ComplianceText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports